module.exports = __webpack_public_path__ + "media/images/search-focus-0dd6a4733297b17edbd2d402c4ba2771.png";